import PRE_EXCHANGE_CONFIG from "../config/preExchangeConfig";
import ChecklistPage from "./ChecklistPage";

export default function PreExchangeChecklist() {
  return <ChecklistPage config={PRE_EXCHANGE_CONFIG} checklistType="pre_exchange" />;
}
